<template>
  <div class="adminContainer">
    <H4>DASHBOARD VIEW FOR SENIOR! NEEDS WORK!!!</H4>  
    <b-tabs content-class="mt-3" justified>
    <b-tab title="By Company" active><p>Devices By Company</p></b-tab>
    <b-tab title="By Location"><p>Devices By Locations</p></b-tab>
    <b-tab title="By Status"><p>Devices By Status</p></b-tab>
  </b-tabs>
  
  </div>
</template>

<script>
// import CompanyDashboard from "@/components/SUPCompanyDashboard.vue";
// import CommsDashboard from "@/components/SUPCommsDashboard.vue";
// import DeviceDashboard from "@/components/SUPDeviceDashboard.vue";

export default {
  components: {
    // CompanyDashboard,
    // CommsDashboard,
    // DeviceDashboard,
  },

  data() {
    return {
      perPage: 10,
      currentPage: 1,
      AlarmItems: [],
      UserHeaders: [],
      ArrTest: [],
      ErrorHeaders: [],
      ErrorItems: [],
      SupportItems: [],
      SupportHeaders: [],
      ServiceItems: [],
      ServiceHeaders: [],
      location: "",
      locations: [],
      filteredlocations: [],
      modal: false,
      GreenCount: "--",
      AmberCount: "--",
      RedCount: "--",
      responseArray: [],
      responselist: [],
      CompanyName: this.$Company,
      GoodState: "",
      ExcellentState: "",
      BadState: "",
      FairState: "",
      locationsArray: [],
      locationsList: [],
      deviceLocation: "",
      hover: false,
      TodayDate: "",
      TotalDevices: "",
      time: "",
      value: "999",
      max: "999",
      UserURN: this.$UserURN,
      UserName: this.$FullName,
      DeviceMessage: "",

      selectedDashboard: "Company",

      selectedSearch: "",
    };
  },

  async mounted() {},

  methods: {},

  watch: {
    location() {
      this.filterLocations();
    },
  },
};
</script>

<style scoped>
input[type="text"],
select {
  width: 100%;

  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  border-radius: 15px;

  background-color: rgb(245, 245, 245);
}

div {
  float: left;
  width: 100%;
  padding: 10px;
}

.row {
  border-style: none;
}

ul {
  float: left;
  margin: 0;
  padding: 0;
}

li {
  float: left;
}
#unitByStatus {
  margin-top: 10px;
}

table {
  color: black;
}
h4 {
  color: black;
}

h5 {
  font-size: 1rem;
}

.tablinksActive {
  width: 25%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 25%;
}

div.tab {
  padding: 0;
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 33.3%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 33.3%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 33.3%;
}

.reportTabActive {
  width: 33.3%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}

.tabcontent {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
</style>
